module.exports = __webpack_public_path__ + "img/cross.3cd7a777.svg";